import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { BarTitle } from "../components/CollapseBar";
import { Network, ChevronDown, ChevronRight } from "lucide-react";
import Mutabakat from "../components/Mutabakat";
import MutabakatOzet from "../components/MutabakatOzet";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
const K = ({ l, v, cls = "text-white" }) => <><span className="text-slate-400">{l}</span><b className={cls}>{v}</b></>;

function Side({ title, b }) {
  return (
    <div className="rounded-lg bg-slate-950/50 p-2">
      <div className="mb-1 text-[10px] font-bold text-slate-400">{title}</div>
      <div className="grid grid-cols-2 gap-x-2 gap-y-0.5 text-[11px]">
        <K l="KARGO" v={b.adet} /><K l="TOPLAM" v={tl(b.toplam)} /><K l="TAHSİL" v={tl(b.tahsil)} cls="text-emerald-300" />
        <K l="KALAN" v={tl(b.kalan)} cls={b.kalan > 0 ? "text-rose-300" : "text-emerald-300"} /><K l="TESLİM" v={b.teslim} /><K l="BEKLEYEN" v={b.bekleyen} cls={b.bekleyen ? "text-amber-300" : "text-white"} />
      </div>
    </div>
  );
}

function Board({ g }) {
  const [open, setOpen] = useState(true);
  const t = g.toplam;
  return (
    <div data-testid={`gb-${g.id}`} className="rounded-xl border border-slate-800 bg-slate-900">
      <button data-testid={`gb-toggle-${g.id}`} onClick={() => setOpen(!open)} className="flex w-full flex-wrap items-center gap-3 px-4 py-3 text-left">
        {open ? <ChevronDown className="h-4 w-4 text-slate-400" /> : <ChevronRight className="h-4 w-4 text-slate-400" />}
        <span className="text-base font-bold text-white">{g.name}</span><span className="text-xs text-slate-400">{g.members.length} FİRMA</span>
        <span data-testid={`gb-total-${g.id}`} className="ml-auto flex flex-wrap gap-3 text-xs"><span>{t.adet} KARGO</span><span>TOPLAM <b className="text-white">{tl(t.toplam)}</b></span><span>TAHSİL <b className="text-emerald-300">{tl(t.tahsil)}</b></span><span>KALAN <b className="text-rose-300">{tl(t.kalan)}</b></span><span>BEKLEYEN <b className="text-amber-300">{t.bekleyen}</b></span></span>
      </button>
      {open && <div className="space-y-3 px-4 pb-4">
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {g.members.map((m) => (
            <div key={m.tenant} data-testid={`gb-member-${g.id}-${m.tenant}`} className="space-y-2 rounded-lg border border-slate-800 p-3">
              <div><div className="font-bold text-white">{m.name}</div><div className="text-[10px] text-sky-300">{m.iller.join(", ") || "—"}</div></div>
              <div className="grid grid-cols-2 gap-2"><Side title="GÖNDERDİĞİ" b={m.gonderilen} /><Side title="ALDIĞI (DAĞITACAĞI)" b={m.gelen} /></div>
            </div>
          ))}
        </div>
        <div className="overflow-auto rounded-lg border border-slate-800">
          <table className="w-full text-[11px] text-slate-200">
            <thead><tr className="border-b border-slate-700 text-left text-slate-400">{["GÖNDEREN", "→ ALAN", "KARGO", "TOPLAM", "TAHSİL", "KALAN", "TESLİM", "BEKLEYEN"].map((h) => <th key={h} className="px-2 py-1.5">{h}</th>)}</tr></thead>
            <tbody>
              {g.pairs.length === 0 && <tr><td colSpan={8} className="px-2 py-4 text-center text-slate-500">BU ARALIKTA KARŞILIKLI KARGO YOK</td></tr>}
              {g.pairs.map((p) => (
                <tr key={`${p.from}>${p.to}`} data-testid={`gb-pair-${p.from}-${p.to}`} className="border-b border-slate-800">
                  <td className="px-2 py-1 font-semibold">{p.from_name}</td><td className="px-2 py-1 font-semibold text-sky-300">{p.to_name}</td><td className="px-2 py-1">{p.adet}</td>
                  <td className="px-2 py-1">{tl(p.toplam)}</td><td className="px-2 py-1 text-emerald-300">{tl(p.tahsil)}</td><td className={`px-2 py-1 font-bold ${p.kalan > 0 ? "text-rose-300" : ""}`}>{tl(p.kalan)}</td>
                  <td className="px-2 py-1">{p.teslim}</td><td className={`px-2 py-1 ${p.bekleyen ? "text-amber-300" : ""}`}>{p.bekleyen}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>}
    </div>
  );
}

export default function GrupPanosu() {
  const [d1, setD1] = useState(""); const [d2, setD2] = useState("");
  const [list, setList] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => { api.get("/group-board", { params: { d1, d2 } }).then((r) => setList(r.data)); }, [d1, d2]);
  const inp = "h-9 rounded border border-slate-700 bg-slate-800 px-2 text-slate-100";
  return (
    <div data-testid="group-board-page" className="mw-fade-up space-y-3">
      <BarTitle><h1 className="font-head flex items-center gap-2 text-2xl font-bold text-white"><Network className="h-6 w-6 text-emerald-400" /> GRUP PANOSU</h1></BarTitle>
      <div className="flex flex-wrap items-center gap-2 text-sm text-slate-300">İLK <input data-testid="gb-d1" type="date" value={d1} onChange={(e) => setD1(e.target.value)} className={inp} />
        SON <input data-testid="gb-d2" type="date" value={d2} onChange={(e) => setD2(e.target.value)} className={inp} />
        <span className="text-xs text-slate-500">SADECE GRUP İÇİ KARGO VE TAHSİLAT TOPLAMLARI — MÜŞTERİ VE KASA BİLGİSİ GÖSTERİLMEZ</span></div>
      {list && list.length === 0 && <div className="text-sm text-slate-500">DAHİL OLDUĞUNUZ ORTAKLIK GRUBU YOK</div>}
      {list?.map((g) => <Board key={g.id} g={g} />)}
      {list && list.length > 0 && <><Mutabakat onChange={() => setTick((x) => x + 1)} /><MutabakatOzet tick={tick} /></>}
    </div>
  );
}
